import { Box, Grid, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import podarImg1 from '../../../../assets/podar1.png'

const BreadCrumb = ({title, detail}) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const theme_color = '#0169b0';

    return (
        <>
            <Grid sx={{ backgroundColor: '#0169b0', alignItems: 'center', justifyContent: 'center', py: 15, px: isMobile ? 1 : 5, position: 'relative', overflow: 'hidden' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant='h3' sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', my: 1 }}>{title}</Typography>
                </Box>
                {detail && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant='h6' sx={{ textAlign: 'center', color: 'white', width: '70%' }}>{detail}</Typography>
                </Box>}
                <Box sx={{ backgroundColor: '#a6c8dfff', width: 170, height: 170, borderRadius: 100 / 2, position: 'absolute', bottom: -40, left: -40, opacity: 0.2 }}>

                </Box>
                <Box sx={{ backgroundColor: '#a6c8dfff', width: 200, height: 200, borderRadius: 100 / 2, position: 'absolute', top: -30, right: -30, opacity: 0.2 }}>

                </Box>
                <Box style={{ position: 'absolute', bottom: 0, left: 80 }}>
                    <img src={podarImg1} style={{ width: 180, height: 'auto', display: isMobile ? 'none' : 'block' }} />
                </Box>
            </Grid>
        </>
    )
}

export default BreadCrumb